import UsersPage from '@/features/companies/[companyId]/users/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/companies/$companySlug/users')({
  component: UsersPage,
})
